import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const saleTeamsService = {};

saleTeamsService.listSaleTeams = ({ params }) => {
  const columnFilter = params.columnFilter || {};
  const apiParams = {
    ...columnFilter,
    page: params.page || 1,
    "per-page": params.sizePerPage || 10,
    sort: params.sort || "-maker_date",
  };

  if (params.keywords) {
    apiParams.keywords = params.keywords;
  }
  if (params.expand) {
    apiParams.expand = params.expand;
  }
  if (params.fields) {
    apiParams.fields = params.fields;
  }
  if (params.parent_hub_name) {
    apiParams.parent_hub_name = params.parent_hub_name;
  }

  return fetchV2({
    url: `${env.API_MSP}/sale-teams`,
    method: "get",
    params: apiParams,
  });
};

// Detail Sales Team
saleTeamsService.detailSaleTeams = ({ saleTeamsId }) => {
  return fetchV2({
    url: `${env.API_MSP}/sale-teams/${saleTeamsId}`,
    method: "get",
    params: {
      expand: "maker,checker,hub",
    },
  });
};

// Update Sales Team
saleTeamsService.updateSaleTeams = ({ saleTeamsId, data }) => {
  return fetchV2({
    url: `${env.API_MSP}/sale-teams/${saleTeamsId}`,
    method: "put",
    data,
  });
};

// Active Sales Team
saleTeamsService.activeSaleTeams = ({ saleTeamsId, data }) => {
  return fetchV2({
    url: `${env.API_MSP}/sale-teams/${saleTeamsId}/active`,
    method: "put",
    data,
  });
};

// Inactive Sales Team
saleTeamsService.inactiveSaleTeams = ({ saleTeamsId, data }) => {
  return fetchV2({
    url: `${env.API_MSP}/sale-teams/${saleTeamsId}/inactive`,
    method: "put",
    data,
  });
};

export default saleTeamsService;
